import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 1024px;
	height: 720px;
	background-color: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	box-shadow: 0px 6px 80px rgba(0, 0, 0, 0.5);
	border-radius: 10px;
	overflow: hidden;
	padding: 30px 30px 0;
`;

const StyledHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-bottom: 20px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledHeadLeftContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledHeadRightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	${Text} {
		font-size: 16px;
		color: rgba(255, 255, 255, 0.5);

		span {
			font-weight: 500;
			color: #ffffff;
		}
	}
`;

const StyledHeadMenuContainer = styled.div`
	padding: 20px 0;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export {
	StyledContainer,
	StyledHead,
	StyledHeadLeftContainer,
	StyledHeadMenuContainer,
	StyledHeadRightContainer,
};
